import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { noop } from 'ui-components/default-props/noop';
import { Checkbox } from 'ui-components/components/checkbox';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './group-by-grid.module.less';

export const GroupByGrid = ({
  items = emptyArray,
  columns = emptyArray,
  selectedIds = emptyArray,
  rowClassName = '',
  columnClassName = '',
  className = '',
  setSelectedIds = noop,
  parentPath = '',
  buildLinkPath = noop,
}) => {
  const [lastIndex, setLastIndex] = useState(null);

  const onClick = (e, item, index) => {
    const checked = selectedIds.includes(item.id);
    const newCheckedValue = !checked;
    let newSelectedIds = [...selectedIds];

    if (newCheckedValue) {
      if (e.shiftKey && lastIndex !== null && selectedIds.length > 0) {
        const [start, end] = lastIndex > index ? [index, lastIndex] : [lastIndex, index];

        for (let i = start; i <= end; i++) {
          newSelectedIds.push(items[i].id);
        }
      } else {
        newSelectedIds.push(item.id);
      }
    } else if (e.shiftKey && lastIndex !== null && selectedIds.length > 0) {
      const [start, end] = lastIndex > index ? [index, lastIndex] : [lastIndex, index];
      const removedIds = [];

      for (let i = start; i <= end; i++) {
        removedIds.push(items[i].id);
      }

      newSelectedIds = newSelectedIds.filter((id) => removedIds.indexOf(id) === -1);
    } else {
      newSelectedIds = newSelectedIds.filter((id) => id !== item.id);
    }
    setSelectedIds([...new Set(newSelectedIds)]);
    setLastIndex(index);
  };

  const selectAlert = useCallback(
    (alertId, index) => {
      setSelectedIds([alertId]);
      setLastIndex(index);
    },
    [setSelectedIds],
  );

  return (
    <div className={classnames(style['group-by-grid'], className)}>
      {items.map((item, index) => {
        const batchLinkPath = buildLinkPath(parentPath, item);
        const checked = selectedIds.includes(item.id);
        return (
          <div
            key={item.id}
            className={classnames(style['group-by-grid-row'], rowClassName, {
              [style.selected]: selectedIds.includes(item.id),
            })}
          >
            <div className={classnames(style['checkbox-column'], style.column)}>
              <Checkbox checked={checked} inputId='group-by-grid' largeCheckbox onChange={noop} onClick={(e) => onClick(e, item, index)} />
            </div>
            <Link
              className={classnames(style['grid-columns'], columnClassName)}
              onClick={() => selectAlert(item.alertId, index)}
              to={batchLinkPath}
            >
              {columns.map((column) => (
                <div key={column.id} className={classnames(style.column, column.className)}>
                  {column.render(item)}
                </div>
              ))}
            </Link>
            <Link className={style['chevron-column']} onClick={() => selectAlert(item.alertId, index)} to={batchLinkPath}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Link>
          </div>
        );
      })}
    </div>
  );
};

GroupByGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      render: PropTypes.func,
      id: PropTypes.string,
      className: PropTypes.string,
    }),
  ),
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  rowClassName: PropTypes.string,
  columnClassName: PropTypes.string,
  className: PropTypes.string,
  setSelectedIds: PropTypes.func,
  parentPath: PropTypes.string,
  buildLinkPath: PropTypes.func,
};
